import { render, staticRenderFns } from "./PackageShop.vue?vue&type=template&id=0c65fc6a&"
import script from "./PackageShop.vue?vue&type=script&lang=js&"
export * from "./PackageShop.vue?vue&type=script&lang=js&"
import style0 from "./PackageShop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports